<div class="member-eligibility">
	<div class="row">
		<div class="col-md-12">
			<div [innerHTML]="message"></div>
		</div>
	</div>
</div>
